(ns dashboard.components.dialog
  (:require
   [reagent.core :as reagent]
   [re-frame.core :as re-frame]
   [headlessui-reagent.core :as ui]
   [dashboard.utils :refer [cs]]))

(defn dialog [{:keys [state title content]}]
  [ui/transition
   {:show (:is-open? @state)}
   [ui/dialog
    {:open (:is-open? @state)
     :as "div"
     :class "relative z-40"
     :on-close #(swap! state assoc :is-open? false)}
    [ui/transition-child
     {:enter "ease-out duration-300"
      :enter-from "opacity-0"
      :enter-to "opacity-100"
      :leave "ease-in duration-200"
      :leave-from "opacity-100"
      :leave-to "opacity-0"}
     [ui/dialog-overlay
      {:class "fixed inset-0 bg-gray-500 bg-opacity-25 transition-opacity"}]]

    [:div.fixed.z-70.inset-0.overflow-y-auto.mt-12
     [:div.flex.items-end.justify-center.min-h-screen.pt-4.px-4.pb-20.text-center.sm:block.sm:p-0
      ;; This element is to trick the browser into centering the modal contents.
      [:span.hidden.inline-block.h-screen.align-middle
       {:aria-hidden true}
       "&#8203;"]
      [ui/transition-child
       {:enter "ease-out duration-300"
        :enter-from "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
        :enter-to "opacity-100 translate-y-0 sm:scale-100"
        :leave "ease-in duration-200"
        :leave-from "opacity-100 translate-y-0 sm:scale-100"
        :leave-to "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"}
       [ui/dialog-panel
        {:class "relative inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full sm:p-6"}
        [:div
         [ui/dialog-title
          {:class "text-lg font-medium leading-6 text-gray-900"}
          title]
         [:div.mt-2
          content]]]]]]]])
